export default "__VITE_ASSET__D46dmpHn__"